module.exports = __webpack_public_path__ + "media/images/athletes/2140-4e95c81b337e2ce89f4a8840e68f82e5.png";